const lightDataGridStyles = {
  root: {
    '--DataGrid-overlayHeight': '56px',
    border: 0,
    borderRadius: 0,
    p: 0,
    '& .MuiDataGrid-main': {
      gap: 0,
    },
    '& .MuiDataGrid-columnHeaders': {
      borderBottom: 0,
    },
    '& .MuiDataGrid-row:hover': {
      backgroundColor: 'transparent',
    },
    '& .MuiDataGrid-row, & .MuiDataGrid-cell': {
      cursor: 'text',
    },
    '& .MuiDataGrid-row.Mui-selected': {
      backgroundColor: 'transparent',
    },
    '& .MuiDataGrid-row.Mui-selected:hover': {
      backgroundColor: 'transparent',
    },
    '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
      outline: 'none',
    },
    '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within':
      {
        outline: 'none',
      },
    '& .MuiDataGrid-row:last-of-type .MuiDataGrid-cell': {
      borderBottom: '1px solid rgba(224, 224, 224, 1)',
    },
    '& .MuiDataGrid-footerContainer': {
      borderTop: 0,
    },
  },
  emptyState: {
    minHeight: 56,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
};

export default lightDataGridStyles;
